<template>
    <footer :class='{piedPageBlanc: isLogin}' class="pied-page">
        <button @click='goToLegalNotice' class="legal-notice">{{ $t('footer.legalNotice') }}</button>
        <button @click='goToConfidentialite' class="legal-notice">{{ $t('footer.confidentialite') }}</button>
    </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Footer',
    props: {
        connected: {
            type: Boolean,
        },
    },
    computed: {
        isLogin() :boolean {
            return this.$router.currentRoute.value.fullPath === '/login';
        },
    },
    methods: {
        goToLegalNotice() {
            this.$router.push('/cgu');
        },
        goToConfidentialite() {
            this.$router.push('/politique-confidentialite');
        },
    }
});
</script>

<style scoped>
.pied-page {
    background-color: var(--background-principal);
    padding: 0 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;
    cursor: pointer;
}
.legal-notice {
    font-size: var(--font-size-very-small);
    font-weight: var(--font-weight-very-small);
    color: var(--color-principal);
    text-decoration: none;
    padding: 0 50px;
    height: 30px;
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
}
@media screen and (min-width: 980px) {
    .container {
        padding: 0 50px;
    }
}
.piedPageBlanc {
    background-color: white;
}
</style>
